"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  placeholder: 'Zeit auswählen',
  rangePlaceholder: ['Startzeit', 'Endzeit']
};
var _default = exports.default = locale;